import { Component, OnInit, Input } from '@angular/core';
import { DirectoryUser } from 'src/app/shared/models/school.directory';

export interface DirectoryListing {
  profile: DirectoryUser;
  department: string;
  school: string;
}

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class ListingComponent implements OnInit {
  @Input() listing: DirectoryListing;
  dummyPhoto = '../../assets/default-user.jpg';

  constructor() { }

  ngOnInit(): void { }

  onImgError(event: Event): void {
    (event.target as HTMLImageElement).src = this.dummyPhoto;
  }

}
